import { render, staticRenderFns } from "./stands-to-complete.vue?vue&type=template&id=bace0066&"
import script from "./stands-to-complete.vue?vue&type=script&lang=js&"
export * from "./stands-to-complete.vue?vue&type=script&lang=js&"
import style0 from "./stands-to-complete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports